












import VueOptions from '@utils/VueOptions'

# USAGE 
# Types: info, cta, warning, error
# Button Action : alert = { label: 'PUSH THIS', action: => @pushthis() } 
# Button Route: alert = { label: 'View Events', nav: { name: 'EventShowPage', params: { eventId: 'foo', tab: 'overview' } } }
# Button URL : alert = { label: 'Register', link: 'https://www.recess.is' }
settings =
  vue:
    name: 'AlertBar'
    props: ['alert']
    data: ->
      show: true
    computed:
      alertStyle: ->
        info: 'bg-white text-recess'
        cta: 'bg-white text-recess'
        alert: 'bg-red text-white'
        error: '' 
    methods: 
      dismiss: -> 
        @setAppSession("dismissed-#{@alert.id}-#{@alert.message}", true)
        @show = false
      handleActionClicked: -> @alert.button.action()
    mounted: ->
      @show = !@getAppSession("dismissed-#{@alert.id}-#{@alert.message}")

export default VueOptions.vue settings
